export const COLORS = {
  primary: "#c5945c",
  secondary: "#1A1925",
  additional: "#fdfcdc",
};
